import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface Inputs {
  open: any;
  onClose: any;
  onSelection: any;
}

export default function Activity(props: Inputs) {
  const useStyles = makeStyles((theme: Theme) => ({
    button: {
      margin: theme.spacing(2),
    }
  }));

  const classes = useStyles();

  if (props.open === false) {
    return null;
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dri-title"
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle id="dri-title">Change Activity</DialogTitle>
        <Button variant="outlined"
                className={classes.button}
                style={{color: "green"}}
                disableElevation
                onClick={() => props.onSelection("NORM")}>Normal Replenishment (NORM)</Button>
        <Button variant="outlined"
                className={classes.button}
                style={{color: "red"}}
                disableElevation
                onClick={() => props.onSelection("PREM")}>Product Removal (PREM)</Button>
        <Button variant="outlined"
                className={classes.button}
                style={{color: "red"}}
                disableElevation
                onClick={() => props.onSelection("DISP")}>Disposal (DISP)</Button>              
        <Button variant="outlined"
                className={classes.button}
                style={{color: "grey"}}
                disableElevation
                onClick={() => props.onSelection("")}>Abort</Button>
    </Dialog>
  );
}
